import { loadScript } from '../utils/loadScript';

import { resolveFlag } from './launchDarkly';

export class OptimoveService {
  private static initPromise: Promise<void> | null = null;
  private static isInitialized = false;

  private static isEnabled() {
    return resolveFlag('optimove_enabled', false);
  }

  static async init() {
    if (!this.isEnabled()) {
      return;
    }

    if (!this.initPromise) {
      this.initPromise = (async () => {
        try {
          const tenantId = import.meta.env.VITE_OPTIMOVE_TENANT_ID;
          const tenantToken = import.meta.env.VITE_OPTIMOVE_TENANT_TOKEN;
          const workerPath = '/OptimoveSDKWorker.js';
          const src = `https://sdk.optimove.net/v2/websdk/?tenant_id=${tenantId}&tenant_token=${tenantToken}`;
          await loadScript(src, {
            'data-optimove-service-worker-path': workerPath,
          });
          this.isInitialized = true;
        } catch (e) {
          console.error('Optimove initialization failed', e);
          throw e;
        }
      })();
    }
    return this.initPromise;
  }

  static async waitForInit() {
    if (this.isInitialized) {
      return;
    }
    if (!this.initPromise) {
      await this.init();
    } else {
      await this.initPromise;
    }
  }

  static async login(userId: string) {
    if (!this.isEnabled()) {
      return;
    }
    await this.waitForInit();
    if (this.isInitialized) {
      const pageTitle = 'Main Page';
      const pageUrl = window.location.href;
      optimoveSDK.API.setPageVisit(pageUrl, pageTitle);
      optimoveSDK.API.setUserId(userId);
    }
  }
}
